import axios from "axios";
import store from "../stores/store";
import { showNotification } from "../slices/notificationSlice";
import { getToken, getTokenPayload } from "../../token/token";
import Cookies from "js-cookie";

const handleSubdomain = () => {
  let subdomain = getTokenPayload("token");
  const isEmptyObject =
    subdomain &&
    typeof subdomain === "object" &&
    !Array.isArray(subdomain) &&
    Object.keys(subdomain).length === 0;

  subdomain =
    subdomain == null || subdomain === "" || isEmptyObject
      ? "superadmin"
      : subdomain?.subDomain;
  const customTenant = Cookies.get("custom_tenant");
  const hideTenantId = [""];

  if (customTenant) {
    return {
      "Content-Type": "application/json",
      "X-Tenant-Id": customTenant,
    };
  }

  if (subdomain === "www" || subdomain === "localhost") {
    return {
      "Content-Type": "application/json",
    };
  } else {
    return {
      "Content-Type": "application/json",

      "X-Tenant-Id": subdomain,
    };
  }
};

let AuthAPI = axios.create({
  baseURL: process.env.REACT_APP_BASEURL_VARIABLE_ECOMMERCE,
  headers: handleSubdomain(),
});

AuthAPI.interceptors.request.use(
  (config) => {
    const token = getToken("token") || null;
    if (token) {
      config.headers["Authorization"] = "Bearer " + token;
    }

    return config;
  },
  (error) => {
    Promise.reject(error);
  },
);

AuthAPI.interceptors.response.use(
  (response) => {
    if (
      (response.data.success &&
        window.location.pathname.split("/").indexOf("auth") === -1 &&
        response.config.method === "post") ||
      response.config.method === "put" ||
      response.config.method === "delete"
    ) {
      store.dispatch({
        type: showNotification,
        payload: {
          type: "success",
          message: response?.data?.message || "Somthing went wrong!",
        },
      });
    }

    return response;
  },
  function (error) {
    store.dispatch({
      type: showNotification,
      payload: {
        type: "error",
        message:
          error?.response?.data?.message ||
          error?.response?.data?.error ||
          "Something went wrong! Please check your internet connecton.",
      },
    });

    return Promise.reject(error);
  },
);

let EcommerceAPI = axios.create({
  baseURL: process.env.REACT_APP_BASEURL_VARIABLE_ECOMMERCE,
  headers: handleSubdomain(),
});

EcommerceAPI.interceptors.request.use(
  (config) => {
    const token = getToken("token") || null;
    if (token) {
      config.headers["Authorization"] = "Bearer " + token;
    }

    return config;
  },
  (error) => {
    Promise.reject(error);
  },
);

EcommerceAPI.interceptors.response.use(
  (response) => {
    if (
      (response.data.success &&
        window.location.pathname.split("/").indexOf("auth") === -1 &&
        response.config.method === "post") ||
      response.config.method === "put" ||
      response.config.method === "delete"
    ) {
      store.dispatch({
        type: showNotification,
        payload: {
          type: "success",
          message: response?.data?.message || "Somthing went wrong!",
        },
      });
    }

    return response;
  },
  function (error) {
    store.dispatch({
      type: showNotification,
      payload: {
        type: "error",
        message:
          error?.response?.data?.message ||
          error?.response?.data?.error ||
          "Something went wrong! Please check your internet connecton.",
      },
    });

    return Promise.reject(error);
  },
);

let CommonAPI = axios.create({
  baseURL: process.env.REACT_APP_BASEURL_VARIABLE_COMMON,
  headers: handleSubdomain(),
});

CommonAPI.interceptors.request.use(
  (config) => {
    const token = getToken("token") || null;
    if (token) {
      config.headers["Authorization"] = "Bearer " + token;
    }

    return config;
  },
  (error) => {
    Promise.reject(error);
  },
);

CommonAPI.interceptors.response.use(
  (response) => {
    if (
      (response.data.success &&
        window.location.pathname.split("/").indexOf("auth") === -1 &&
        response.config.method === "post") ||
      response.config.method === "put" ||
      response.config.method === "delete"
    ) {
      store.dispatch({
        type: showNotification,
        payload: {
          type: "success",
          message: response?.data?.message || "Somthing went wrong!",
        },
      });
    }

    return response;
  },
  function (error) {
    store.dispatch({
      type: showNotification,
      payload: {
        type: "error",
        message:
          error?.response?.data?.message ||
          error?.response?.data?.error ||
          "Something went wrong! Please check your internet connecton.",
      },
    });

    return Promise.reject(error);
  },
);

export { AuthAPI, EcommerceAPI, CommonAPI };
export default AuthAPI;
